import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-view-render',
  templateUrl: './view-render.component.html',
  styleUrls: ['./view-render.component.scss']
})
export class ViewRenderComponent implements ICellRendererAngularComp {

  params: any;
  getLabelFunction: any;

  agInit(params: any): void {
    this.params = params;
    this.getLabelFunction = this.params.getLabelFunction;
  }

  refresh(params?: any): boolean {
    return true;
  }
  
  isPopup(): boolean {
    return false;
  }

  onClick($event) {
    // console.log('show details',$event);
    // console.log('params: ',this.params);
    if (this.params.onClick instanceof Function) {
      const params = {
        event: $event,
        rowData: this.params.node,
      };
      this.params.onClick(params);
    }
  }

}